function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-2{fill:#fff}\n        "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_5081",
  "data-name": "Group 5081",
  transform: "translate(451.461 690.697)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_5037",
  "data-name": "Group 5037",
  transform: "translate(1046 300.337)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_5036",
  "data-name": "Group 5036",
  transform: "translate(4.791)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_3381",
  "data-name": "Path 3381",
  className: "cls-2",
  d: "M120.3-200.392a1 1 0 0 0-1 1v3.647a1 1 0 0 0 1 1 1 1 0 0 0 1-1v-3.647a1 1 0 0 0-1-1z",
  transform: "translate(-119.304 200.392)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3382",
  "data-name": "Path 3382",
  className: "cls-2",
  d: "M126.355-200.392a1 1 0 0 0-1 1v3.647a1 1 0 0 0 1 1 1 1 0 0 0 1-1v-3.647a1 1 0 0 0-1-1z",
  transform: "translate(-118.304 200.392)"
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_3383",
  "data-name": "Path 3383",
  className: "cls-2",
  d: "M116.536-198.663h13.155v1.951h-13.155a1.008 1.008 0 0 0-1.009 1.006v10.192a1.008 1.008 0 0 0 1.009 1.006h13.15a1.008 1.008 0 0 0 1.009-1.006v-10.192a1.008 1.008 0 0 0-1.009-1.006.977.977 0 0 1-.978-.975.977.977 0 0 1 .978-.975 2.96 2.96 0 0 1 2.964 2.957v10.192a2.96 2.96 0 0 1-2.964 2.957h-13.15a2.96 2.96 0 0 1-2.964-2.957v-10.192a2.96 2.96 0 0 1 2.964-2.958z",
  transform: "translate(-113.572 200.392)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_5670",
  "data-name": "Rectangle 5670",
  className: "cls-2",
  width: 4.298,
  height: 4.298,
  rx: 0.5,
  transform: "rotate(90 .326 8.763)"
})));

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, /*#__PURE__*/React.createElement("g", {
    id: "Group_7455",
    "data-name": "Group 7455",
    transform: "translate(-1484 -977)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4351",
    "data-name": "Rectangle 4351",
    width: 46,
    height: 46,
    rx: 10,
    transform: "translate(1484 977)",
    style: {
      fill: "#ebf3f5",
      opacity: 0.25
    }
  }), _ref3));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.56d6f085.svg";
export { ForwardRef as ReactComponent };